import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react"
import { api } from "../../contracts";
import { ExtraContent } from "../../contracts/extraContent/dto";
import { useCourse } from "../course";

type ExtraContentContextData = {
    list: ExtraContent[],
    current?: ExtraContent,
    getList: () => Promise<ExtraContent[]>,
    changeList: (list: ExtraContent[]) => void,
    changeCurrent: (id: number) => void,
}

const DEFAULT: ExtraContentContextData = {
    list: [],
    current: undefined,
    getList: () => { return Promise.resolve([]) },
    changeList: () => { },
    changeCurrent: () => { }
}

const ExtraContentContext = createContext(DEFAULT);

export const ExtraContentProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();

    const [list, setList] = useState<ExtraContent[]>([]);
    const [current, setCurrent] = useState<ExtraContent>();

    const getList = useCallback(async () => {
        console.log('cheguei aqui 9')
        const response = await api.extraContent.getList(type);
        setList(response);

        return response;
    }, [type]);

    const changeList = useCallback((list: ExtraContent[]) => {
        setList(list);
    }, []);

    const changeCurrent = useCallback((id: number) => {
        setCurrent(list.find(l => l.id === id));
    }, [list]);


    return (
        <ExtraContentContext.Provider
            value={{
                list,
                current,
                getList,
                changeList,
                changeCurrent
            }}>
            {children}
        </ExtraContentContext.Provider>
    )
}

export function useExtraContent(): ExtraContentContextData {
    const context = useContext(ExtraContentContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}